import { PriceContext } from '@context/priceContext'
import { useContext } from 'react'

export function usePrice() {
  return useContext(PriceContext)
}
